export default __webpack_public_path__ + "static/media/PM.e0721029.svg";